// Fisher–Yates shuffle. Unlike Array.prototype.sort(() => Math.random() - 0.5),
// this produces a uniformly random permutation.
export function shuffle(array) {
  const result = array.slice();
  for (let i = result.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [result[i], result[j]] = [result[j], result[i]];
  }
  return result;
}
